module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (42).295bfcfc.png";